import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { ProcessingButton, Button } from "@qgiv/core-donor";

const SaveAndContinue = ({
    hasClassifications,
    handleClick,
    buttonLabel,
    emailVerificationInFlight,
}) => {
    const { isSubmitting } = useFormikContext();
    return (
        <div
            className={`col col--12 ${
                hasClassifications ? "col--xl-5" : "col--xl-6"
            }`}
        >
            {isSubmitting ? (
                <ProcessingButton />
            ) : (
                <Button
                    disabled={emailVerificationInFlight}
                    classes={emailVerificationInFlight ? "-disabled" : ""}
                    // this was originally a button type of "submit" to automatically
                    // submit the form through Formik. Since we need to set the field value for
                    // what type of submit this is ("Save and Continue" vs. "Add New Registrant")
                    // and possibly do email validation, this button is now set to type "button"
                    type="button"
                    name="Save_And_Continue_To_Payment"
                    onClick={(e) =>
                        handleClick(e, { addNewRegistration: false })
                    }
                >
                    {buttonLabel}
                </Button>
            )}
        </div>
    );
};

SaveAndContinue.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    emailVerificationInFlight: PropTypes.bool.isRequired,
    hasClassifications: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
};

export default SaveAndContinue;
